/* ===============================
   SITES
================================ */
export const sites = [
   {
    id: "1",
    siteId: "U2040",
    name: "AMAZON SERVICES,CAPITAL COURT, MUNIRKA",
    region: "Asia Pacific",
    country: "India",
    state: "Delhi",
    lat: 28.5531,
    lng: 77.2525,
    manager: "MGR_2",
    manager_name: "Shri Ram",
    minRequiredPerShift: {
      A: 4,
      B: 3,
      C: 2,
      G: 1
    }
  },
  {
    id: "2",
    siteId: "U4337",
    name: "YUSEN BADARPUR-FORMELY SONY",
    region: "Asia Pacific",
    country: "India",
    state: "Delhi",
    lat: 28.5331,
    lng: 77.2425,
    manager: "MGR_1",
    manager_name: "Mohit",
    minRequiredPerShift: {
      A: 5,
      B: 4,
      C: 3,
      G: 2
    }
  }
];

export const shifts = {
  A: { label: "Morning", start: "7AM", end:"3PM", hours: 8 },
  B: { label: "Evening", start: "3PM", end:"11PM", hours: 8 },
  C: { label: "Night", start: "11PM", end:"7AM", hours: 8 },
  G: { label: "General", start: "8AM", end:"8PM", hours: 12 },
  R: {label: "Rest", start: "", end: "", hours: 12},
  H: {label: "Holiday", start: "", end: "", hours: 24},
};

export const designations = 
  [ { label: "SG" },
   { label: "Sr SG" },
   { label: "ASO", },
   { label: "GM" }
  ]


/* ===============================
   EMPLOYEES (GLOBAL POOL)
================================ */
export const employees = [
  {
      id: "MGR_1",
      name: "Mohit",
      phone: "23000111",
      designation: "Area Manager",
         primaryUnitId: "U4337",
    homeSiteId: "U4337" 
    },

  {id: "SEN042908", "name":	"MANISH PATKAR", phone:"9555172178",  
    designation: "Security Guard",
    primaryUnitId: "U4337",
    homeSiteId: "U4337" },
{id: "SEN043037",	name: "SUNDAR SINGH BISHT", phone:"9811929605", designation: "Security Guard",
    primaryUnitId: "U4337",
    homeSiteId: "U4337" },
{id: "C1191",	name:"CHAKRADHAR PANDEY", number:"9873110599", designation: "Sr. Security Guard",
    primaryUnitId: "U4337",
    homeSiteId: "U4337" },
{id: "SEN043090", name:	"ARJUN SINGH",  	number:"9354448980", designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "SEN044820", name:	"ANKIT TIWARI", number:"8292927700", designation: "Sr. Security Guard",
    primaryUnitId: "U4337",
    homeSiteId: "U4337" },
{id: "SEN052004", name:	"DHRUV KUMAR", number:"9455030276", designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "SEN041278", name: "SANJAY KUMAR SINGH", number: "9718884908", designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "SEN042404", name:	"JAGPAL SINGH", number:  	"9540662314", designation: "Sr. Security Guard",
    primaryUnitId: "U4337",
    homeSiteId: "U4337" },
{id: "SEN042906", name:	"AKILESH SHARMA", number: "9315695877",  designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "SEN042624", name:	"DHARMENDRA SINGH SENGAR", number:"6397981906", designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "SEN042403", name:	"CHANDARSHEKHAR", number:"9870350591", designation: "Security Guard",
    primaryUnitId: "U4337",
    homeSiteId: "U4337" },
{id: "V3782", name:	"VISHNU GURJAR", number:"6377989519", designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id:"P4852", name:	"PRAVEEN KUMAR", number:"9582186246",  designation: "Sr. Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "SEN044201", name:	"PAWAN KUMAR SHARMA", number:"8003130872", designation: "Security Guard",
    primaryUnitId: "U4337",
    homeSiteId: "U4337" },
{id: "V3769", name:	"VIRENDRA KUMAR", number:"8750613179", designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "SEN042909", name:"SATRUGHAN THAKUR", number:"9718018105", designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "A8588", name:	"AJEET SINGH", number:"7503065441",  designation: "Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },
{id: "SEN050101", name:	"RAHUL KUMAR PASWAN", number:"8521886246",  designation: "Sr. Security Guard",
    primaryUnitId: "UNIT_ICU_OKLA",
    homeSiteId: "U4337" },


    {
      id: "MGR_2",
      name: "Shri Ram",
      phone: "44900111",
      designation: "Area Manager",
      primaryUnitId: "U2040",
    homeSiteId: "U2040" 
    },

  { id: "SEN040834",	name:"AKHLESH KUMAR", phone:"8745850245", designation: "Security Guard",
    primaryUnitId: "U2040",
    homeSiteId: "U2040" },
 {id: "SEN049372",name:	"KEERTIVARDHANAM", phone: "9718180221", 
designation: "Security Guard",
    primaryUnitId: "U2040",
    homeSiteId: "U2040" },
  {id:"A8725-S1", name:"ASHEESH SINGH", phone:"8922985868",
designation: "Security Guard",
    primaryUnitId: "U2040",
    homeSiteId: "U2040" },


  
];


export const rosters = 
  [
    {
      id: "RST_1",
      month: "01-01-2026",
      SECTOR: "DELHI I",
      AREA_MANAGER: "SRI RAM",
      siteId: "U2040",
      UNIT: "AMAZON SERVICES,CAPITAL COURT, MUNIRKA",
      employees: [{ employeeId: "SEN040834", shift:"G"},{ employeeId:  "SEN049372",shift:"G"},{ employeeId:  "A8725-S1", shift:"G"},
        { employeeId: "K3518-S1",shift:"G"},{ employeeId: "SEN049770", shift:"G"},{ employeeId: "SEN049371",shift:"G"},
        { employeeId: "SEN041851", shift:"G"},{ employeeId: "SEN052773",shift:"G"},{ employeeId:  "SEN049340",shift:"G"},
        { employeeId: "A9000-R1", shift:"G"},{ employeeId: "SEN046186",shift:"G"},{ employeeId: "U1025-S2", shift:"G"},
        { employeeId: "J2619-R1", shift:"G"},{ employeeId: "SEN055088", shift:"G"},{ employeeId: "SEN053474", shift:"G"},
        { employeeId:  "V3740-S2",shift:"G"}
      ],
    },
    {
      id: "RST_2",
      month: "01-01-2026",
      SECTOR: "OKHLA",
      AREA_MANAGER: "MOHIT",
      siteId: "U4337",
      UNIT: "YUSEN BADARPUR-FORMELY SONY",      
      employees: [{employeeId: "SEN042908", shift: "A",},
    {
        employeeId: "SEN043037",
        shift: "A",
        
    },
    {
        employeeId: "C1191",
        shift: "A",
        
    },
    {
        employeeId: "SEN043090",
        shift: "A",
        
    },
    {
        employeeId: "SEN044820",
        shift: "A",
        
    },
    {
        employeeId: "SEN052004",
        shift: "A",
        
    },
    {
        employeeId: "SEN041278",
        shift: "A",
        
    },
    {
        employeeId: "SEN042404",
        shift: "B",
        
    },
    {
        employeeId: "SEN042906",
        shift: "B",
        
    },
    {
        employeeId: "SEN042624",
        shift: "B",
        
    },
    {
        employeeId: "SEN042403",
        shift: "B",
        
    },
    {
        employeeId: "V3782",
        shift: "B",
        
    },
    {
        employeeId: "P4852",
        shift: "B",
        
    },
    {
        employeeId: "SEN044201",
        shift: "B",
        
    },
    {
        employeeId: "V3769",
        shift: "C",
        
    },
    {
        employeeId: "SEN042909",
        shift: "C",
        
    },
    {
        employeeId: "A8588",
        shift: "C",
        
    },
    {
     
        employeeId: "SEN050101",
        shift: "C",
    }
      ]              
    }
 ];

/* ===============================
   ATTENDANCE (ACTUAL WORK)
   - From biometric / app / manual
================================ */
export const attendance = [
  {
    date: "01-01-2026",
    employeeId: "SEN043037",
    siteId: "U4337",
    shift: "A",
    status: "PRESENT",
    actualStart: "7AM",
    actualEnd: "3PM",
    id: "ATT_001",
  },
   {
    id: "ATT_002",
    date: "01-01-2026",
    employeeId: "SEN043037",
    siteId: "U4337",
    shift: "B",
    status: "PRESENT",
    actualStart: "4PM",
    actualEnd: "11PM",
    hoursWorked: 8
  },
  
   {
    id: "ATT_0022",
    date: "02-01-2026",
    employeeId: "SEN043037",
    siteId: "U4337",
    shift: "B",
    status: "PRESENT",
    actualStart: "4PM",
    actualEnd: "11PM",
    hoursWorked: 8
  },
 
  {
    date: "03-01-2026",
    employeeId: "SEN043037",
    siteId: "U4337",
    shift: "A",
    status: "PRESENT",
    actualStart: "7AM",
    actualEnd: "3PM",
    id: "ATT_0012",
  },
  {
    id: "ATT_0023",
    date: "03-01-2026",
    employeeId: "SEN043037",
    siteId: "U2040",
    shift: "B",
    status: "PRESENT",
    actualStart: "4PM",
    actualEnd: "11PM",
    hoursWorked: 8
  },
   {
    date: "04-01-2026",
    employeeId: "SEN043037",
    siteId: "U4337",
    shift: "A",
    status: "PRESENT",
    actualStart: "7AM",
    actualEnd: "3PM",
    id: "ATT_0011",
  },
  {
    id: "ATT_0024",
    date: "04-01-2026",
    employeeId: "SEN043037",
    siteId: "U4337",
    shift: "B",
    status: "PRESENT",
    actualStart: "4PM",
    actualEnd: "11PM",
    hoursWorked: 8
  },
    {
    id: "ATT_003",
    date: "03-01-2026",
    employeeId: "SEN042403",
    siteId: "U4337",
    shift: "B",
    status: "PRESENT",
       actualStart: "11PM",
    actualEnd: "6AM",
    hoursWorked: 0
  },
  {
    id: "ATT_033",
    date: "05-01-2026",
    employeeId: "SEN042403",
    siteId: "U4337",
    shift: "C",
    status: "PRESENT",
       actualStart: "11PM",
    actualEnd: "6AM",
    hoursWorked: 0
  },
  {
    id: "ATT_007",
    date: "06-01-2026",
    employeeId: "SEN042403",
    siteId: "U4337",
    shift: "A",
    status: "PRESENT",
       actualStart: "7AM",
    actualEnd: "3PM",
    hoursWorked: 0
  },
    { employeeId: "SEN040834",	
      siteId: "U2040",
      shift: "G",
    status: "PRESENT",
    hoursWorked: 0,
    id: "ATT_004",
    date: "05-01-2026",  
       actualStart: "",
    actualEnd: "",  
 },
 {employeeId: "SEN049372",    siteId: "U2040",
      shift: "G",
    status: "PRESENT",
    hoursWorked: 0,
    id: "ATT_005",
    date: "05-01-2026",  
       actualStart: "8AM",
    actualEnd: "8PM", 
  },
  {employeeId:"A8725-S1",     siteId: "U2040",
      shift: "G",
    status: "PRESENT",
    hoursWorked: 0,
    id: "ATT_006",
    date: "05-01-2026",  
       actualStart: "8AM",
    actualEnd: "7PM",
   },


];
